import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
import { UmovmeEnvironmentService } from "../../umovme-environment.service";

@Component({
  selector: "app-umovme-environment-details",
  templateUrl: "./umovme-environment-details.component.html",
  styleUrls: ["./umovme-environment-details.component.scss"],
})
export class UmovmeEnvironmentDetailsComponent implements OnInit {
  subscription = new Subscription();
  goback = "../list/";
  form: FormGroup;
  queryParams: any = {};
  hideToken = true;

  constructor(
    private spinner: NgxSpinnerService,
    private service: UmovmeEnvironmentService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    try {
      this.spinner.show();
      this.form = this.fb.group({
        id: this.fb.control(""),
        name: this.fb.control("", [Validators.required]),
        token: this.fb.control("", [Validators.required]),
        default: this.fb.control(false, [Validators.required]),
        active: this.fb.control(false, [Validators.required]),
      });

      this.route.queryParams.subscribe((params: any) => {
        this.queryParams = params;
        this.load();
      });
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
    }
  }

  async load() {
    try {
      if (this.queryParams.id) {
        this.spinner.show();
        this.subscription.add(
          this.service.detail(this.queryParams.id).subscribe(
            (res) => {
              this.form.patchValue(res.data);
              this.spinner.hide();
            },
            () => {
              this.spinner.hide();
              Alert.error(Alert.getMessage().errors.load);
            }
          )
        );
      }
    } catch (error) {
      this.spinner.hide();
      Alert.error(Alert.getMessage().errors.load).then(() =>
        this.router.navigate([this.goback])
      );
    }
  }

  onSubmit() {
    if (this.form.valid) {
      const action =
        this.form.value.id > 0
          ? this.service.update(this.form.value)
          : this.service.save(this.form.value);
      this.subscription.add(
        action.subscribe(
          () => {
            this.spinner.hide();
            Alert.success(Alert.getMessage().success.save).then(() =>
              this.router.navigate([this.goback])
            );
          },
          () => {
            this.spinner.hide();
            Alert.error(Alert.getMessage().errors.save);
          }
        )
      );
    } else {
      console.log(this.form.valid);
      console.log(this.form.value);
    }
  }
}
